import * as React from "react";
import {useState} from "react";
import AssetModal from "../asset-browser/AssetModal";
import CheckoutModal from "../CheckoutModal";
import AssetBrowser from "../asset-browser/AssetBrowser";
import {DamMediaCenterApiApi} from "../../api";
import type {CartItem} from "../utils/CartHelper";
import {URL_HELPER} from "../../App";

export interface IAPIComponent {
    api: DamMediaCenterApiApi | undefined;
}

export const AssetsPage = ({api}: IAPIComponent) => {
    const [cart, setCart] = useState<Array<CartItem>>(() => JSON.parse(localStorage.getItem("cart_" + URL_HELPER.getMediaCenterId()) || "[]"));
    return (
        <>
            <AssetBrowser api={api} cart={cart} setCart={setCart} />
            <AssetModal api={api} cart={cart} setCart={setCart} />
            <CheckoutModal api={api} cart={cart} setCart={setCart} />
        </>
    );
};
